import React, { useState, useEffect } from "react";
import StudentDashboardCrousel from "../../../Components/layouts/StudentDashboard/StudentDashboardCrousel";
import DashCard from "../../../Components/share/cards/DashCard";
import { BtnAlternative } from "../../../Components/share/buttons/Btn";
import { recomposeColor } from "@material-ui/core";
import useFetch from "../../../Hooks/useFetch";
import Cookies from "js-cookie";

const StudentDash = () => {
    const [courses, setCourses] = useState();
    const [homeworks, setHomeworks] = useState();

    const currentCourse = useFetch({
        method: "GET",
        url: "BootCampService/user_current_bootcamp",
        noHeader: false,
        trigger: true,
        setter: setCourses,
    });

    const upcomingHomeworks = useFetch({
        method: "GET",
        url: "BootCampService/upcoming_homeworks",
        noHeader: false,
        trigger: true,
        setter: setHomeworks,
    });

    console.log(courses);
    console.log(homeworks);

    return (
        <div>
            <h2 className=" text-[2.4rem] text-purple-dark font-medium mb-12">
                {Cookies.get("username")}، خوش آمدید
            </h2>
            <h4 className=" text-[2rem] text-black-prim font-bold mb-16">
                دوره‌های جاری
            </h4>
            <div className="w-4/5 text-center mx-auto ">
                <StudentDashboardCrousel courses={courses?.results} />
            </div>
            <h4 className=" text-[2rem] text-black-prim font-bold mt-[2.1rem] mr-[0.9rem]">
                تکالیف پیش رو
            </h4>
            {homeworks?.results.map((homework) => (
                <DashCard className="flex py-[1.4rem] px-12 justify-between flex-row mt-[2.1rem] items-center">
                    <p className=" text-[#21212199] text-[1.2rem] font-normal leading-[2.4rem]">
                        {homework?.title}
                    </p>
                    <p className=" text-[#21212199] text-[1.2rem] font-normal leading-[2.4rem]">
                        {homework?.time}
                    </p>
                    <BtnAlternative text="ارسال پاسخ" className="px-4 py-7" />
                </DashCard>
            ))}
        </div>
    );
};

export default StudentDash;
